import React from 'react';
import PropTypes from 'prop-types';

import {
  CardBody, CardContainer, ContentContainer, HeaderContainer, HeaderText,
} from './styles';

const SideCardTemplate = ({ title, content, 'data-testid': dataTestId }) => (
  <CardBody>
    <CardContainer data-testid={`${dataTestId}-container`}>
      <HeaderContainer data-testid={`${dataTestId}-header`}>
        <HeaderText
          data-testid={`${dataTestId}-title`}
          className="subtitle-large"
        >
          {title}
        </HeaderText>
      </HeaderContainer>
      <ContentContainer data-testid={`${dataTestId}-content`}>
        {content}
      </ContentContainer>
    </CardContainer>
  </CardBody>
);

SideCardTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  'data-testid': PropTypes.string,
};

SideCardTemplate.defaultProps = {
  'data-testid': 'side-card-template',
};

export default SideCardTemplate;
